var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-form"},[_c('b-tabs',{attrs:{"content-class":"mt-3","fill":"","pills":""}},[_c('b-tab',{attrs:{"title":"Вхід","active":""}},[_c('auth-form-login')],1),_c('b-tab',{attrs:{"title":"Реєстрація"}},[_c('auth-form-register')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }